import { Vehicle } from "@tm/models"
import { equals } from "@tm/utils"

export const isVehicleChanged = (newVeh: Vehicle, oldVeh?: Vehicle) => {
    if (!oldVeh) {
        return true
    }

    const { dataAvailabilities: _, ...newVehWithoutAvailabilites } = newVeh
    const { dataAvailabilities: __, ...oldVehWithoutAvailabilites } = oldVeh
    return !equals(newVehWithoutAvailabilites, oldVehWithoutAvailabilites)
}
